import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageReload } from 'context/languageReloadContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//api
import { getHelpText } from 'api/company';
// own components
import MenuMain from 'components/navbar/HeaderDefault.js';
import Footer from 'components/footer/FooterDefault.js';
import Cookies from 'components/cookiesAlert/cookies.js';

const DefaultLayout = (props) => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const { contentLanguage } = useLanguageReload();
  const [isDesktop, setIsDesktop] = useState(true);
  const [helpTextList, setHelpTextList] = useState([]);

  useEffect(() => {
    const getDevice = () => setIsDesktop(window.innerWidth > 991);

    getDevice();

    window.addEventListener('resize', getDevice);

    return () => {
      window.removeEventListener('resize', getDevice);
    };
  }, []);

  useEffect(() => {
    const getHelpTextList = async () => {
      const response = await getHelpText({ active: true });
      if (response?.status === 200) {
        setHelpTextList(response?.data?.results);
      }
    };

    getHelpTextList();
  }, [i18n.language]);

  return (
    <>
      <MenuMain isDesktop={isDesktop} helpTextList={helpTextList} />
      <Cookies />
      <main className={location.pathname.includes('/mapa') ? 'margin-md mt-3' : 'margin-md mt-3 mainDiv'}>
        <Outlet key={contentLanguage} />
      </main>
      <Footer helpTextList={helpTextList} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="container-toastify"
      />
    </>
  );
};

export default DefaultLayout;
